import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-reveal"
// Adds the "in-view" class once the element scrolls into the viewport.
export default class extends Controller {
    connect() {
        if (!("IntersectionObserver" in window)) {
            this.element.classList.add("in-view")
            return
        }

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.element.classList.add("in-view")
                    this.observer.disconnect()
                }
            })
        }, { threshold: 0.35 })

        this.observer.observe(this.element)
    }

    disconnect() {
        this.observer?.disconnect()
    }
}
